export const optionAll = {
  id: 'all',
  name: 'All'
};

export const minSearchLength = 3;
